import RefNavbar from './RefNavbar';
import RefAbout from './RefAbout';

function Page2026About() {
  return (
    <>
      <RefNavbar />
      <RefAbout />
    </>
  );
}

export default Page2026About;
